import type {ReactElement} from 'react';
import {useState} from 'react';
import {ToggleSwitch, ToggleSwitchV2Size} from '@Components/toggle-switch-v2';
import {ToggleSwitchStyleVariant} from '@Components/toggle-switch-v2/toggle-switch-v2.types';
import {Icon} from '@Components/icon-v2';
import {IconShape, IconSize, IconType} from '@Components/icon-v2/icon.types';
import {Text, TextSize} from '@Components/text';
import {noop} from '@Utils/general.util';
import '@Global/modal';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import {REEL_TOGGLE_TOOLTIP_ID} from './reel-toggler.types';
import type {ReelTogglerProps} from './reel-toggler.types';
import styles from './reel-toggler.module.scss';

export function ReelToggler({onReelToggle = noop, isToggled = false, isDisabled = false, disabledTooltipText = ''}: ReelTogglerProps): ReactElement {
  const [reelToggleState, setReelToggleState] = useState<boolean>(isToggled);

  const onToggle = (): void => {
    const newToggleValue = !reelToggleState;
    setReelToggleState(newToggleValue);
    onReelToggle(newToggleValue);
  };

  const getToggleSwitch = (): ReactElement => {
    const toggleSwitch = (
      <ToggleSwitch
        isDisabled={isDisabled}
        isChecked={reelToggleState}
        onChange={onToggle}
        ariaLabel={window.i18next.t('pmwjs_post_video_as_reel')}
        size={ToggleSwitchV2Size.MEDIUM}
        variant={ToggleSwitchStyleVariant.COMPACT}
      />
    );

    if (isDisabled && disabledTooltipText !== '') {
      return (
        <OverlayTrigger
          trigger={['hover', 'focus', 'click']}
          overlay={
            <Tooltip className="_pointer-events-none" style={{position: 'fixed'}} id={REEL_TOGGLE_TOOLTIP_ID}>
              {disabledTooltipText}
            </Tooltip>
          }
          delay={{show: 50, hide: 50}}
          placement="top"
          popperConfig={undefined}
          show={undefined}
          defaultShow={undefined}
          onHide={undefined}
          onToggle={undefined}
          target={undefined}
          flip={undefined}
          offset={undefined}
        >
          <span className={styles.tooltipTriggerWrapper}>{toggleSwitch}</span>
        </OverlayTrigger>
      );
    }

    return toggleSwitch;
  };

  return (
    <div className={styles.reelTogglerRow}>
      <div className={styles.reelTogglerLabel}>
        <Icon icon="icon-insta-reels" size={IconSize.SIZE_ICON_16} type={IconType.NONE} shape={IconShape.NONE} />
        <Text val={window.i18next.t('pmwjs_post_video_as_reel')} size={TextSize.MD} />
      </div>
      {getToggleSwitch()}
    </div>
  );
}
